import { defineMessages } from '@jutro/locale';

export default defineMessages({
    zipcodeEnteredForDiffState: {
        id: 'ml.gateway.MLAddressChangeNewStatePopup."ZIP code entered is for a different state',
        defaultMessage: 'ZIP code entered is for a different state'
    },
    movingToNewState: {
        id: 'ml.gateway.MLAddressChangeNewStatePopup.If moving to a new state',
        defaultMessage: 'If moving to a new state, you will need to {strongSpan}.'
    },
    startNewQuote: {
        id: 'ml.gateway.MLAddressChangeNewStatePopup.START A NEW QUOTE',
        defaultMessage: 'START A NEW QUOTE'
    },
    youAreMovingToNewState: {
        id: 'ml.gateway.MLAddressChangeNewStatePopup.If you are moving to a new state',
        defaultMessage: 'If you are moving to a new state, you will need to {strongSpan}.'
    },
    cancel: {
        id: 'ml.gateway.MLAddressChangeNewStatePopup.CANCEL',
        defaultMessage: 'CANCEL'
    }
});
